/* eslint-disable import/prefer-default-export */

import {
  ref, watch, unref, isRef,
} from 'vue';

export const useZip = (array, composable, options = {}) => {
  const zipped = ref([]);
  const { reactive = false, initializer } = options;

  const resolveInitializer = (item) => {
    if (initializer === null) {
      return [];
    }
    if (initializer) {
      return initializer(item);
    }
    return [item];
  };

  const update = () => {
    const arr = unref(array);
    const result = arr.map((item) => {
      const args = resolveInitializer(item);
      const composableResult = composable(...args);
      return [item, composableResult];
    });
    zipped.value = result;
  };
  update();

  if (reactive) {
    watch(isRef(array) ? () => array.value.length : () => array.length, update);
  }

  return zipped;
};
